import { Injectable, } from "@angular/core";
import {
    HttpClient,
    HttpHeaders,
    HttpParams,
    HttpErrorResponse,
  } from '@angular/common/http'
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

// const msalInstance = new Msal.UserAgentApplication(msalConfig);

@Injectable({
    providedIn: 'root'
})
export class ApiService{

    api: string = environment.API_URL

    constructor(
        private http: HttpClient
    ){}

    getCourses(): Observable<any>{
        return this.http.get(`${this.api}/api/courses`)
    }

    getDreams(): Observable<any>{
        return this.http.get(`${this.api}/api/dreams`)
    }

    getInterests(): Observable<any>{
        return this.http.get(`${this.api}/api/interests`)
    }

    getAffiliates(): Observable<any>{
        return this.http.get(`${this.api}/api/affilates`)
    }

    getGenders(): Observable<any>{
        return this.http.get(`${this.api}/api/genders`)
    }

    getDescription(): Observable<any>{
        return this.http.get(`${this.api}/api/description`)
    }

    sendUserForm(form: any): Observable<any>{
        return this.http.post(`${this.api}/customers`, form)
    }
    
    sendUserFormTo365(form: any): Observable<any>{
        return this.http.post(`${this.api}/api/contact`, form)
    }

    checkUser(form: any): Observable<string[]>{
        return this.http.post<string[]>(`${this.api}/customers/check-user`, form)
    }
}